/* eslint-disable @typescript-eslint/naming-convention */
import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { CpWizardPostFormLayoutConfig } from './types';

export const CP_WIZARD_POST_FORM_LAYOUT_CONFIG: DiToken<CpWizardPostFormLayoutConfig> =
  new DiToken<CpWizardPostFormLayoutConfig>('cpWizardPostFormLayoutConfig');

export const WIZARD_POST_FORM_HIDDEN_FIELDS: DiToken<string[]> = new DiToken<string[]>('wizardPostFormHiddenFields', {
  factory: () => []
});
